export default __webpack_public_path__ + "static/media/dashboard_icon.e91814cf.svg";